<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

			<div
				v-show="pageShowData">

				<div 
					class="row form-group">
					<div class="col"></div>
					<div
						class="col-auto">
						<a href="#" v-on:click.prevent="printPDF" class="btn btn-rounded btn-primary btn-block-xs-only">
							Print
						</a>
					</div>
					
				</div>

				<iframe
					id="billFrame"
					style="width:100%;"
					frameBorder="0"
					v-show="pageShowPV">
				</iframe>

				<div v-show="false" class="invoice-box">
					<div id="print_area" style="background:#fff">
						<br>
						<img class="img_header" v-bind:src="pv['carparkHeader']" style="width: 100%;">
						<br>
						<div style="float:right">
							<h2 class="right" style="font-size: 1.5em; font-weight: bold;">PAYMENT VOUCHER</h2>
							<table>
								<tbody>
									<tr>
										<td>Parking License No:</td>
										<td></td>
										<td class="right"><b>{{pv['parkingLicense']}}</b></td>
										<td></td>
									</tr>
									<tr>
										<td>PV No:</td>
										<td></td>
										<td class="right"><b>{{pv['pvNo']}}</b></td>
										<td></td>
									</tr>
									<tr>
										<td>Date:</td>
										<td></td>
										<td class="right"><b>{{pv['date']}}</b></td>
										<td></td>
									</tr>
									<tr v-show="pv['refundMethod']">
										<td>Refund Method:</td>
										<td></td>
										<td class="right"><b>{{pv['refundMethod']}}</b></td>
										<td></td>
									</tr>
									<tr>
										<td>PV Status:</td>
										<td></td>
										<td class="right"><b>{{pv['pvStatus']}}</b></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div><b>{{pv['carparkName']}}</b>
							<div v-show="pv['carparkAddress1']">{{pv['carparkAddress1']}}</div>
							<div v-show="pv['carparkAddress2']">{{pv['carparkAddress2']}}</div>
							<div v-show="pv['carparkAddress3']">{{pv['carparkAddress3']}}</div>
							<div>{{pv['carparkAddressPostCodeAndCity']}}</div>
							<div>{{pv['carparkAddressStateAndCountry']}}</div>
							<div>Telephone: {{pv['carparkTelephone']}}</div>
							<div>Fax: {{pv['carparkFax']}}</div>
							<div>Email: {{pv['carparkEmail']}}</div>
							<div>Website: {{pv['carparkWebsite']}}</div>
						</div><br>TO:<div><b>{{pv['customerName']}}</b>
							<div v-show="pv['customerAddress1']">{{pv['customerAddress1']}}</div>
							<div v-show="pv['customerAddress2']">{{pv['customerAddress2']}}</div>
							<div v-show="pv['customerAddress3']">{{pv['customerAddress3']}}</div>
							<div>{{pv['customerAddressPostCodeAndCity']}}</div>
							<div>{{pv['customerAddressStateAndCountry']}}</div>
						</div><br>
						<div v-show="pv['customerPIC']">ATTENTION: {{pv['customerPIC']}}</div>
						<table class="bordered-table" style="width: 100%">
							<tbody>
								<tr>
									<th class="bordered-table center" colspan="1" style="">Description</th>
									<th class="bordered-table center" colspan="1" style="">Amount Paid (RM)</th>
								</tr>
								<tr>
									<td class="bordered-table left" colspan="1" style="" >
										<div v-html="(pv['description'] || '').replaceAll('\n', '<br>')"></div>
										<br>
										<b>
											Refund Request Form Reference: {{pv['termination']}}
										</b>
									</td>
									<td class="bordered-table right" colspan="1" style="">{{pv['amount']}}</td>
								</tr>
								<tr>
									<td class="bordered-table right" colspan="1" style=""><b>Total</b></td>
									<td class="bordered-table right" colspan="1" style=""><b>RM {{pv['amount']}}</b></td>
								</tr>
							</tbody>
						</table>
						<br>
						<br>
						We enclose the following refund information in the above items:
						<table class="bordered-table" style="width: auto">
							<tbody>
								<tr
									v-for="(row, index) in pv['refundInfo']"
									v-bind:key="'refund_info_' + index">
									<td class="bordered-table" colspan="1" style="" v-html="row['col1']"></td>
									<td class="bordered-table" colspan="1" style="" v-html="row['col2']"></td>
								</tr>
							</tbody>
						</table>
						<br>
						<br>
						<div>This is a computer generated document. No signature is required</div><br>
						<img class="img_footer" v-bind:src="pv['carparkFooter']" style="width: 100%;">
					</div>
				</div>

        <div v-show="pageShowAdmin">
				<hr>

				<h2><u><b>PV Administration</b></u></h2>

				<br>

				<table>
					<tr>
						<td>PV Refund Method:</td>
						<td>{{pv['refundMethod']}}</td>
					</tr>
					<tr>
						<td>PV Status:</td>
						<td>{{pv['pvStatus']}} (on {{pv['today']}})</td>
					</tr>
					<tr>
						<td class="pr-3">Refund Request Form Reference:</td>
						<td><a target="_blank" v-bind:href="`/plTerminationForm?carparkID=${pv['carparkID']}&applicationID=${pv['terminationApplicationID']}`">{{pv['termination']}}</a></td>
					</tr>
				</table>

				<br>

				<h3>PV Approval Information</h3>
				
				<AppForm
					v-show="pageShowData"
					ref="pageForm" 
					v-bind:formParameter="PARAM"
					v-bind:permission="permission"
          v-on:form-input="onFormInput" >
					
				</AppForm>

        </div>

			</div>

      <TemplateFeedback ref="pageFeedback" />
			
      <div v-show="pageShowAdmin">
      
      <button v-show="pv['pvStatus'] === 'Pending Approval' && pageShowData && hasAddOrEditPermission()" v-on:click="onPendingButtonClick" type="button" class="btn btn-success">
        Approve and Pending Processing (Giro)
      </button>

      <button v-show="pv['pvStatus'] === 'Pending Processing' && pageShowData && hasAddOrEditPermission()" v-on:click="onProcessButtonClick" type="button" class="btn btn-success">
        Set as Processing
      </button>
			
      <button v-show="pv['pvStatus'] === 'Processing' && pageShowData && hasAddOrEditPermission()" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Edit
      </button>
			
      <button v-show="pv['pvStatus'] === 'Processing' && pageShowData && hasAddOrEditPermission()" v-on:click="onCompleteButtonClick" type="button" class="btn btn-danger">
        Complete
      </button>

      </div>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import PagePLViewLease from "@/components/Page/ParkingLicense/PagePLViewLease";

import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import IBGBankConfig from "@/components/Param/IBG"

var querystring = require('querystring');
var moment = require('moment');

let boostrapGridCol6 = {
  'class': 'col-lg-6',
};

const PARAM = [
  {
    key: 'amount',
    text: 'PV Amount',
    form_input_attr: {
      'type': 'Number',
    },
    form_muted: 'Please update with care. You can perform adjustment of PV amount here, but it will not change the amount of CN.',
    form_input_validation: [
      validation.validateRequire,
      validation.validatePositive
    ],
  },
  {
    key: 'description',
    text: 'PV Description',
    form_muted: 'You can perform adjustment of PV description here',
    form_textarea: true,
  },

  {
    key: 'refundMethod',
    text: 'Refund Method',
    form_default: 0,
    // form_input_attr: {
    //   disabled: true,
    // },
    form_select: [
      {0:'GIRO'}, 
      {1:'Cheque'},
    ]
  },
  {
    key: 'terminationGiroSection',
    form_section: 'GIRO Information',
  },
  {
    key: 'terminationGiroAccountHolder',
    text: 'Bank Account Holder Name *',
    form_input_validation: [],
  },
  {
    key: 'terminationGiroEmail',
    text: 'Email *',
    form_input_validation: [],
  },
  {
    key: 'terminationGiroBank',
    text: 'Bank Name *',
    form_input_validation: [],
    form_chosen: true,
    form_select: {
      data: IBGBankConfig,
      formatSelectOptionText: (dataItem) => dataItem.name,
    }
  },
  {
    key: 'terminationGiroBankAccountType',
    text: 'Bank Account Type *',
    form_input_validation: [],
    form_default: 0,
    form_select: [
      {'current':'Current Account'}, 
      {'saving':'Saving Account'},
    ]
  },
  {
    key: 'terminationGiroBankAccountNo',
    text: 'Bank Account No. *',
    form_input_validation: [],
    form_muted: '',
  },
  {
    key: 'terminationGiroVerification',
    form_section: 'GIRO Verification Method',
  },
  {
    key: 'terminationGiroRemark',
    form_html: () => 'Please fill in at least one of the GIRO Verification Method at below.',
  },
  {
    key: 'terminationGiroNewIC',
    text: 'New I/C No.',
    form_input_validation: [],
    form_default: '',
  },
  {
    key: 'terminationGiroOldIC',
    text: 'Old I/C No.',
    form_input_validation: [],
    form_default: '',
  },
  {
    key: 'terminationGiroBusinessRegNo',
    text: 'Business Registration No.',
    form_input_validation: [],
    form_default: '',
  },
  {
    key: 'terminationChequeSection',
    form_section: 'Posting Address Information',
  },
  {
    key: 'terminationChequePayableTo',
    text: 'Cheque Payable To *',
    form_input_validation: [],
  },
  {
    key: 'terminationChequeAddress1',
    text: 'Address 1 *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequeAddress2',
    text: 'Address 2',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequeAddress3',
    text: 'Address 3',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequePostalCode',
    text: 'Postal Code *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
  },
  {
    key: 'terminationChequeCity',
    text: 'City *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'terminationChequeState',
    text: 'State *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
  },
  {
    key: 'terminationChequeCountry',
    text: 'Country *',
    form_container_attr: boostrapGridCol6,
    form_input_validation: [],
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePaymentVoucher",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    PagePLViewLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Payment Voucher', url: '/refundRequest' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,

      pageOperatorTitle: '',
      pageCustomerType: '',

      pageShowData: false,
      pageShowAdmin: false,

			pageCarpark: null,
			pageCarparkAddress: null,
			pageCarparkSeasonSetting: null,

      applicationCache: null,
      licenseCache: null,
      licenseLease: null,

			pv: {},
			pvNo: '',
			pageShowPV: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    if(helper.hasEditPermission(this.permission)) {
      this.pageShowAdmin = true
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/refundRequest');
    });

    this.loadApplication();
  },
  methods: {
    hideFormFromKey(key) {
      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key === 'applicationTotalAccessCard') {
          if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
            parameter.form_hide = false;
          } else {
            parameter.form_hide = true;
          }
          return;
        }

        parameter.form_hide = hide;
      });
    },

    loadApplication() {
      let carparkID = this.$route.query.carparkID;
      let applicationID = this.$route.query.applicationID;
      if(carparkID && applicationID) {
        this.$refs['pageFeedback'].setFeedbackLoading('Loading payment voucher data...');
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?carparkID=' + carparkID + '&applicationID=' + applicationID + '&type1=terminationRefundRequest',
            helper.createAxiosConfig()
          )
          .then(response => {
          	let resultMeta = helper.processAxiosResponse(this, response);
            let tempData = response.data[0];
            if(tempData) {
              this.applicationCache = tempData;
              this.loadLicense();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading payment voucher data.');
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'payment voucher data'));
          })
      } else {
        this.$refs['pageFeedback'].setFeedbackError('Invalid Request');
      }
    },
    loadLicense() {
			this.$refs['pageFeedback'].setFeedbackLoading('Loading license data...');
			this.$http
				.get(
					helper.SERVER_URL + '/api2/license/' + this.applicationCache.licenseID,
					helper.createAxiosConfig()
				)
				.then(response => {
					let resultMeta = helper.processAxiosResponse(this, response);
					let tempData = response.data[0];
					if(tempData) {
						this.licenseCache = tempData;
						this.loadCustomer();
					} else {
						this.$refs['pageFeedback'].setFeedbackError('Problem loading license data.');
					}
				})
				.catch(error => {
					this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
				})
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + this.licenseCache['customerID'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            this.licenseCache['_customer'] = tempData;
            if(tempData['address1']) {
              this.loadCity();
            } else if(tempData['contact1']) {
              this.loadApplicationCustomerContact();
            } else {
              this.loadTenant();
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading customer data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCity() {
      let feedbackItem = 'customer address city'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/city/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCity = response.data;
          helper.inputSelectSetOption(this.PARAM_MAP['terminationChequeCity'], response.data);
          this.loadState();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadState() {
      let feedbackItem = 'customer address state'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/state/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageState = response.data;
          helper.inputSelectSetOption(this.PARAM_MAP['terminationChequeState'], response.data);
          this.loadCountry();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCountry() {
      let feedbackItem = 'customer address country'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/country/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCountry = response.data;
          helper.inputSelectSetOption(this.PARAM_MAP['terminationChequeCountry'], response.data);
          this.loadApplicationCustomerAddress();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadApplicationCustomerAddress() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer address data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + this.licenseCache['_customer']['address1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = helper.parseAddress(response);
          if(tempData) {
            this.licenseCache['_customer'] = Object.assign(tempData, this.licenseCache['_customer']);
            if(tempData['contact1']) {
              this.loadApplicationCustomerContact();
            } else {
              this.loadTenant();
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading customer address data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer address data'));
        })
    },
    loadApplicationCustomerContact() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading customer contact data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/contact/' + this.licenseCache['_customer']['contact1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = helper.parseContact(response);
          if(tempData) {
            this.licenseCache['_customer'] = Object.assign(tempData, this.licenseCache['_customer']);
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading customer contact data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer contact data'));
        })
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            this.pageCarpark = this.licenseCache['_carpark'] = tempData;
            this.loadCarparkAddress();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading car park data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadCarparkAddress() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park address data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + this.licenseCache['_carpark']['addressData1'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = helper.parseAddress(response);
          if(tempData) {
						// if(Object.prototype.toString.call(tempData.address) === "[object String]") {
						// 	tempData.address = JSON.parse(tempData.address);
						// }
            this.pageCarparkAddress = tempData;
            this.loadCarparkFinance();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading car park address data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park address data'));
        });
    },
    loadCarparkFinance() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park info data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'] + '/finance',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
						this.pageCarparkFinance = tempData
            this.pageOperatorTitle = tempData.name;
            this.loadCarparkSeasonSetting();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading car park info data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park info data'));
        });
    },
    loadCarparkSeasonSetting() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park detail data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.licenseCache['carparkID'] + '/seasonSetting',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            this.pageCarparkSeasonSetting = tempData.name;
            this.loadInvoice();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading car park detail data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park detail data'));
        });
    },
    loadInvoice() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading invoice data...');
      this.$http
        .get(
          helper.SERVER_URL + `/api2/invoice?billType=INV&customerID=${this.licenseCache['customerID']}&carparkID=${this.licenseCache['carparkID']}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data;
          if(tempData) {
            this.pageInvoice = tempData;
            this.loadDebitNote();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading invoice data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'invoice data'));
        });
    },
    loadDebitNote() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading debit note data...');
      this.$http
        .get(
          helper.SERVER_URL + `/api2/invoice?billType=DN&customerID=${this.licenseCache['customerID']}&carparkID=${this.licenseCache['carparkID']}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data;
          if(tempData) {
            this.pageDebitNote = tempData;
            this.loadCreditNote();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading debit note data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'debit note data'));
        });
    },
    loadCreditNote() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading credit note data...');
      this.$http
        .get(
          helper.SERVER_URL + `/api2/invoice?billType=CN&customerID=${this.licenseCache['customerID']}&carparkID=${this.licenseCache['carparkID']}`,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data;
          if(tempData) {
            this.pageCreditNote = tempData;
            this.loadLicenseComplete();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading credit note data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'credit note data'));
        });
    },

    formAddress(key, data, temp, tempKey) {
      let addressParam = ['Address1', 'Address2', 'Address3', 'AddressPostalCode', 'AddressCityID', 'AddressStateID', 'AddressCountryID'];
      let address = '';
      addressParam.forEach(k => {
        if(data[key + k]) {
          if(k === 'AddressCityID') {
            let city = this.pageCity.find(j => helper.compareID(data[key + k], j.id));
            if(city) {
              data[key + 'AddressStateID'] = city['stateID'];
              address += (address ? ', ' : '') + city['name'];
              temp[tempKey + 'AddressCityName'] = city['name'];
              return;
            }
          } else if(k === 'AddressStateID') {
            let state = this.pageState.find(j => helper.compareID(data[key + k], j.id));
            if(state) {
              data[key + 'AddressCountryID'] = state['countryID'];
              address += (address ? ', ' : '') + state['name'];
              temp[tempKey + 'AddressStateName'] = state['name'];
              return;
            }
          } else if(k === 'AddressCountryID') {
            let country = this.pageCountry.find(j => helper.compareID(data[key + k], j.id));
            if(country) {
              address += (address ? ', ' : '') + country['name'];
              temp[tempKey + 'AddressCountryName'] = country['name'];
              return;
            }
          }
          address += (address ? ', ' : '') + data[key + k];
					temp[tempKey + k] = data[key + k];
        }
      });
      return address;
    },

    loadLicenseComplete() {
      this.$refs['pageFeedback'].setFeedbackError();

      if(Object.prototype.toString.call(this.applicationCache['dataRef']) === "[object String]") {
        this.applicationCache['dataRef'] = JSON.parse(this.applicationCache['dataRef']);
      }

			this.pv = {}
      this.pv['parkingLicense'] = helper.plFormPLNum(this.licenseCache['licenseOperatorNum'], this.licenseCache['carparkID']);
      this.pvNo = this.pv['pvNo'] = helper.plFormPVNum(this.applicationCache['applicationID'], this.licenseCache['carparkID']);
      this.pv['date'] = moment.unix(this.applicationCache['date1']).format('DD/MM/YYYY');
      this.pv['refundMethod'] = this.applicationCache['dataRef']['refundMethod'] === '0' ? 'GIRO' : 'Cheque'
      this.pv['pvStatus'] = this.applicationCache['status1']

			// if(!this.carparkSeasonSetting['NoSST']) {
			// 	this.pv['sst'] = this.carparkSeasonSetting.sstNumber;
			// }
			
      this.pv['carparkHeader'] = this.pageCarparkFinance['logoHeader']
      this.pv['carparkFooter'] = this.pageCarparkFinance['logoFooter']
      this.pv['carparkName'] = this.pageCarpark.name;

      this.pv['carparkAddress1'] = this.pageCarparkAddress.address1;
      this.pv['carparkAddress2'] = this.pageCarparkAddress.address2;
      this.pv['carparkAddress3'] = this.pageCarparkAddress.address3;
			let carparkCity = this.pageCity.find(j => helper.compareID(this.pageCarpark.cityID, j.id));
      this.pv['carparkAddressPostCodeAndCity'] = this.pageCarparkAddress.addressPostalCode + ' ' + carparkCity['name'];
			let carparkState = this.pageState.find(j => helper.compareID(carparkCity.stateID, j.id));
			let carparkCountry = this.pageCountry.find(j => helper.compareID(carparkState.countryID, j.id));
      this.pv['carparkAddressStateAndCountry'] = carparkState['name'] + ', ' + carparkCountry['name'];

			// console.log(this.pageCarparkAddress)
			// this.formAddress('', this.pageCarparkAddress, this.pv, 'carpark');
			// this.pv['carparkAddressPostCodeAndCity'] = this.pv['addressPostalCode'] + ' ' + this.pv['carparkAddressCityName'];
			// this.pv['carparkAddressStateAndCountry'] = this.pv['carparkAddressStateName'] + ', ' + this.pv['carparkAddressCountryName'];
			// console.log(this.pv)
			
      this.pv['carparkTelephone'] = this.pageCarpark.telephone;
      this.pv['carparkFax'] = this.pageCarpark.fax;
      this.pv['carparkEmail'] = this.pageCarpark.email;
      this.pv['carparkWebsite'] = this.pageCarpark.website;
      // this.pv['carparkAddress1'] = this.pageCarparkAddress[''];
			
      let customer = this.licenseCache['_customer'];

      if(customer.isCompany) {
        this.pv['customerName'] = `${customer['name']} (${customer['nationalID']})`;
        this.pageCustomerType = this.licenseCache['licenseType'] = 'Company';
				
        this.formAddress('company', customer, this.pv, 'customer');
				this.pv['customerAddressPostCodeAndCity'] = this.pv['customerAddressPostalCode'] + ' ' + this.pv['customerAddressCityName'];
				this.pv['customerAddressStateAndCountry'] = this.pv['customerAddressStateName'] + ', ' + this.pv['customerAddressCountryName'];
				
	      this.pv['customerTelephone'] = customer['companyTelephone'];
				this.pv['customerPICName'] = customer['companyPICname'];
				this.pv['customerPICMobile'] = customer['companyPICphone'];
				this.pv['customerPICEmail'] = customer['companyPICemail'];
        this.pv['customerPIC'] = `${this.pv['customerPICName']} (${this.pv['customerPICMobile']})`;
      } else {
        this.pv['customerName'] = `${customer['name']} (${customer['nationalID']})`;
        // this.pv['licensePersonalNationalID'] = customer['nationalID'];
        // this.pv['licensePersonalEmail'] = customer['personalEmail'];
        // this.pv['licensePersonalPhoneMobile'] = customer['personalPhoneMobile'];
        // this.pv['licensePersonalPhoneResidential'] = customer['personalPhoneResidential'];

        this.formAddress('personalCorrespondence', this.pv, 'customer');
				this.pv['customerAddressPostCodeAndCity'] = this.pv['customerAddressPostalCode'] + ' ' + this.pv['customerAddressCityName'];
				this.pv['customerAddressStateAndCountry'] = this.pv['customerAddressStateName'] + ', ' + this.pv['customerAddressCountryName'];

	      this.pv['customerTelephone'] = customer['personalPhoneMobile'];
        // this.pv['licensePersonalEmergencyName'] = customer['emergencyName'];
        // this.pv['licensePersonalEmergencyRelationship'] = customer['emergencyRelationship'];
        // this.pv['licensePersonalEmergencyPhoneResidential'] = customer['emegencyPhoneResidential'];
        // this.pv['licensePersonalEmergencyPhoneOffice'] = customer['emegencyPhoneOffice'];
        // this.pv['licensePersonalEmergencyPhoneMobile'] = customer['emegencyPhoneMobile'];

        // this.pv['licenseCompanyName'] = customer['companyName'];
        // this.pv['licenseCompanyNationalID'] = customer['companyNationalID'];
        this.pageCustomerType = this.pv['licenseType'] = 'Personal';

        // this.pv['licenseDeclarationPerson'] = this.pv['licensePersonalName'] + ' (' + this.licenseCache['licensePersonalNationalID'] + ')';
      }

			this.pv['description'] = this.applicationCache['dataRef']['description'] || ''

			if(!this.pv['description']) {
				// for(let invoice of this.pageInvoice) {
        //   if(this.applicationCache['dataRef'] && this.applicationCache['dataRef']['depositRefundCN'] && this.applicationCache['dataRef']['depositRefundCN'].length > 0) {
        //     if(invoice['type'] === 'Deposit INV') {
        //       this.pv['description'] += this.pv['description'] ? '\n' : ''
        //       this.pv['description'] += 'Refund Deposit: ' + helper.plBillNum(invoice.creditNum || invoice.debitNum || invoice.invoiceNum, invoice.carparkID, invoice['type']);
        //     }
        //   }
				// 	// if(invoice['lockDate']) {
				// 	// 	this.pv['description'] += this.pv['description'] ? '\n' : ''
				// 	// 	this.pv['description'] += 'Refund Balance: ' + helper.plBillNum(invoice.creditNum || invoice.debitNum || invoice.invoiceNum, invoice.carparkID, invoice['type']);
				// 	// }
				// }
				// for(let invoice of this.pageDebitNote) {
				// 	if(invoice['lockDate']) {
				// 		this.pv['description'] += this.pv['description'] ? '\n' : ''
				// 		this.pv['description'] += 'Refund Balance: ' + helper.plBillNum(invoice.creditNum || invoice.debitNum || invoice.invoiceNum, invoice.carparkID, invoice['type']);
				// 	}
				// }
				for(let invoice of this.pageCreditNote) {
					if(invoice['lockDate']) {
						this.pv['description'] += this.pv['description'] ? '\n' : ''
            if(invoice['type'] === 'Deposit Refund CN') {
						  this.pv['description'] += 'Refund Deposit: '
            } else {
						  this.pv['description'] += 'Refund Balance: '
            }
            this.pv['description'] += helper.plBillNum(invoice.creditNum || invoice.debitNum || invoice.invoiceNum, invoice.carparkID, invoice['type']);
					}
				}
			}

			this.pv['terminationApplicationID'] = this.applicationCache['data1']
			this.pv['termination'] = helper.plFormPLTNum(this.applicationCache['data1'], this.licenseCache['carparkID']);
			this.pv['amount'] = helper.formatMoney(this.applicationCache['data3'] || this.applicationCache['data2'])

			this.pv['refundInfo'] = []
			this.pv['col1'] = []
			this.pv['col2'] = []

			if(this.applicationCache['dataRef']['refundMethod'] === '0') {
				this.pv['refundInfo'].push({col1: 'GIRO Bank Name', col2: this.applicationCache['dataRef']['terminationGiroBankName'].trim()})
				this.pv['col1'].push('GIRO Bank Name')
				this.pv['col2'].push(this.applicationCache['dataRef']['terminationGiroBankName'].trim())
				this.pv['refundInfo'].push({col1: 'GIRO Bank Account Holder Name', col2: this.applicationCache['dataRef']['terminationGiroAccountHolder'].trim()})
				this.pv['col1'].push('GIRO Bank Account Holder Name')
				this.pv['col2'].push(this.applicationCache['dataRef']['terminationGiroAccountHolder'].trim())
				this.pv['refundInfo'].push({col1: 'GIRO Bank Account No.', col2: this.applicationCache['dataRef']['terminationGiroBankAccountNo'].trim()})
				this.pv['col1'].push('GIRO Bank Account No.')
				this.pv['col2'].push(this.applicationCache['dataRef']['terminationGiroBankAccountNo'].trim())
				if(this.applicationCache['dataRef']['terminationGiroBusinessRegNo']) {
					this.pv['refundInfo'].push({col1: 'GIRO Bank Account Identity Verification', col2: 'Business Registration No: ' + this.applicationCache['dataRef']['terminationGiroBusinessRegNo']})
          this.pv['col1'].push('GIRO Bank Account Identity Verification')
          this.pv['col2'].push(this.applicationCache['dataRef']['terminationGiroBusinessRegNo'].trim())
				} else if(this.applicationCache['dataRef']['terminationGiroNewIC']) {
					this.pv['refundInfo'].push({col1: 'GIRO Bank Account Identity Verification', col2: 'New IC: ' + this.applicationCache['dataRef']['terminationGiroNewIC']})
          this.pv['col1'].push('GIRO Bank Account Identity Verification')
          this.pv['col2'].push(this.applicationCache['dataRef']['terminationGiroNewIC'].trim())
				} else if(this.applicationCache['dataRef']['terminationGiroOldIC']) {
					this.pv['refundInfo'].push({col1: 'GIRO Bank Account Identity Verification', col2: 'Old IC: ' + this.applicationCache['dataRef']['terminationGiroOldIC']})
          this.pv['col1'].push('GIRO Bank Account Identity Verification')
          this.pv['col2'].push(this.applicationCache['dataRef']['terminationGiroOldIC'].trim())
				}
			} else if(this.applicationCache['dataRef']['refundMethod'] === '1') {
				this.pv['refundInfo'].push({col1: 'Cheque Payable To', col2: this.applicationCache['dataRef']['terminationChequePayableTo'].trim()})
				this.pv['col1'].push('Cheque Payable To')
				this.pv['col2'].push(this.applicationCache['dataRef']['terminationChequePayableTo'].trim())

				let chequeAddress = ''
				if(this.applicationCache['dataRef']['terminationChequeAddress1']) {
					chequeAddress += chequeAddress ? '<br>' : ''
					chequeAddress += this.applicationCache['dataRef']['terminationChequeAddress1']
				}
				if(this.applicationCache['dataRef']['terminationChequeAddress2']) {
					chequeAddress += chequeAddress ? '<br>' : ''
					chequeAddress += this.applicationCache['dataRef']['terminationChequeAddress2']
				}
				if(this.applicationCache['dataRef']['terminationChequeAddress3']) {
					chequeAddress += chequeAddress ? '<br>' : ''
					chequeAddress += this.applicationCache['dataRef']['terminationChequeAddress3']
				}
				let refundCity = this.pageCity.find(j => helper.compareID(this.applicationCache['dataRef']['terminationChequeCity'], j.id));
				chequeAddress += chequeAddress ? '<br>' : ''
				chequeAddress += this.applicationCache['dataRef']['terminationChequePostalCode'] + ' ' + refundCity['name'];
				let refundState = this.pageState.find(j => helper.compareID(refundCity['stateID'], j.id));
				let refundCountry = this.pageCountry.find(j => helper.compareID(refundState['countryID'], j.id));
				chequeAddress += chequeAddress ? '<br>' : ''
				chequeAddress += refundState['name'] + ' ' + refundCountry['name'];
				this.pv['refundInfo'].push({col1: 'Address', col2: chequeAddress})
				this.pv['col1'].push('Address')
				this.pv['col2'].push(chequeAddress)
			}

			this.pv['today'] = moment().format('DD/MM/YYYY')

			let formData = this.applicationCache['dataRef']
			formData['amount'] = this.pv['amount']
			formData['description'] = this.pv['description']
      this.$refs['pageForm'].setForm(false, formData, this.pv['pvStatus'] !== 'Completed');
      this.invalidateRefundMethod()

			$('#jt-form-input-description').css('min-height', '150px')
			this.$nextTick(() => autosize($('#jt-form-input-description')), 500)

			let that = this;
			$('#billFrame').on('load', function() {
				$("#billFrame").contents().find("body").css('background', '#fff')
				$("#billFrame").contents().find("body").css('background-color', '#fff')

				that.pageShowPV = true;

				that.$nextTick(() => {
					// var iframeDocument = this.contentDocument || this.contentWindow.document;
					// this.style.height = iframeDocument.body.offsetHeight + 10 + "px";
					// console.log(1, iframeDocument.body.offsetHeight)
					// console.log(2, $("#billFrame").contents().find("#print_area")[0].offsetHeight)
					$("#billFrame").css('height', $("#billFrame").contents().find("#print_area")[0].offsetHeight + 100)
				})

				// var iframeContent = iframeDocument.body;
				// var html = iframeDocument.body.innerHTML;
				// iframeDocument.body.innerHTML = "";

				// var div = iframeDocument.createElement("div");
				// div.id = "print_area";
				// iframeDocument.body.appendChild(div);

				// $("#billFrame").contents().find("#print_area").append(html);
				// $("#billFrame").contents().find("th")
				//   .css({ 
				//     "border-bottom": "1px solid black", 
				//     "border-right": "1px solid black", 
				//     "border-top": "1px solid black", 
				//     "border-left": "1px solid black", 
				//   });

				// let imageHeader = iframeDocument.getElementsByClassName("img_header");
				// imageHeader[0].style.width = '800px';
				// // imageHeader[0].style.height = '56.6px';
				// let imageFooter = iframeDocument.getElementsByClassName("img_footer");
				// imageFooter[0].style.width = '800px';
				// // imageFooter[0].style.height = '120px';
			});

			document.getElementById('billFrame').src = 'pv?' + querystring.stringify(this.pv);
			// console.log('pv?' + querystring.stringify(this.pv))

			this.pageShowData = true
    },
    
    printPDF() {
      document.getElementById('billFrame').contentWindow.print();
			
			// var doc = new jsPDF('p', 'pt', 'a4', true);
			// var doc = new jsPDF();
			// var that = this;

			// doc.fromHTML(
			// 	$('#print_area')[0],
			// 	15,
			// 	15,
			// 	{
			// 		'width': 800,
			// 	}, function() {
			// 	doc.save(that.pvNo + '.pdf');
			// });

			// doc.addHTML($('#print_area')[0], 15, 15, {
			// 	'background': '#fff',
			// 	// 'width': '800px',
			// }, function() {
			// 	doc.save(that.pvNo + '.pdf');
			// });

			// html2canvas($("#print_area"), {
			// 	onrendered: function(canvas) {         
			// 			var imgData = canvas.toDataURL('image/png'); 
			// 			$("#imgRes").attr("src", imgData);             
			// 			var doc = new jsPDF('p', 'mm');
			// 			doc.addImage(imgData, 'PNG', 10, 10);
			// 			doc.save(that.pvNo + '.pdf');
			// 	}
			// });

			// var mywindow = window.open('', 'PRINT', 'width: 800');
			// mywindow.document.write('<html><head><title>Payment Voucher</title>');
			// mywindow.document.write('<link href="/static/css/style.css?1=1" rel="stylesheet">');
			// mywindow.document.write('</head><body background="#fff">');
			// mywindow.document.write(document.getElementById('print_area').innerHTML);
			// mywindow.document.write('</body></html>');
			// mywindow.document.close(); // necessary for IE >= 10
			// mywindow.focus(); // necessary for IE >= 10*/
			// mywindow.print();
			// mywindow.close();
    },
    tableToJson(table) {
			var data = [];
		
			// first row needs to be headers
			var headers = [];
			for (var i = 0; i < table.rows[0].cells.length; i++) {
				headers[i] = table.rows[0].cells[i].innerHTML.toLowerCase().replace(/ /gi, '');
			}
		
			// // for data pagination
			// for (var i = 0; i < fillerRow; i++) {
				// data.push({});
			// }
		
			// go through cells
			for (var i = 0; i < table.rows.length; i++) {
				var tableRow = table.rows[i];
				var rowData = {};
		
				for (var j = 0; j < tableRow.cells.length; j++) {
					var text = tableRow.cells[j].innerHTML;
					text = text.startsWith('-') ? text.replace('-', '') : text;
					rowData[headers[j]] = text;
				}
				
				data.push(rowData);
			}
		
			return data;
    },
    walkDOM(main) {
      var arr = [];
      var loop = function(main) {
        do {
          if(main.nodeType == 1) {
            if(main.id === 'jt-feedback-lease') {
              continue;
            }

            if(main.childNodes.length === 0) {
              continue;
            }

            arr.push(main);
          }
              
          if(main.hasChildNodes()) {
            loop(main.firstChild);
          }
        }
        while (main = main.nextSibling);
      }
      loop(main);
      return arr;
		},

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'refundMethod') {
        this.invalidateRefundMethod();
      } else if(formParameter.key === 'terminationChequeCity') {
        this.onFormCityChange();
      }
    },
    onFormCityChange() {
      let formData = this.$refs['pageForm'].formData;
      formData['terminationChequeState'] = null;
      formData['terminationChequeCountry'] = null;
      
      let selectedCity = helper.inputSelectFindOption(PARAM_MAP['terminationChequeCity'], formData['terminationChequeCity']);
      if(!selectedCity) {
        return this.$refs['pageForm'].$forceUpdate();
      }

      let selectedState = helper.inputSelectFindOption(PARAM_MAP['terminationChequeState'], selectedCity.stateID);
      if(!selectedState) {
        return this.$refs['pageForm'].$forceUpdate();
      }
      formData['terminationChequeState'] = selectedState.id;

      let selectedCountry = helper.inputSelectFindOption(PARAM_MAP['terminationChequeCountry'], selectedState.countryID);
      if(!selectedCountry) {
        return this.$refs['pageForm'].$forceUpdate();
      }
      formData['terminationChequeCountry'] = selectedCountry.id;
      return this.$refs['pageForm'].$forceUpdate();
    },
    invalidateRefundMethod() {
      let refundMethod = this.$refs['pageForm'].formData['refundMethod'];
      this.PARAM.forEach(parameter => {
        if(parameter.key && parameter.key.startsWith('terminationGiro')) {
          parameter.form_hide = !helper.compareID(refundMethod, 0);
          return;
        }

        if(parameter.key && parameter.key.startsWith('terminationCheque')) {
          parameter.form_hide = !helper.compareID(refundMethod, 1);
          return;
        }
      });
    },
    validateRefundMethod() {
      let formData = this.$refs['pageForm'].formData;
      if(helper.compareID(formData['refundMethod'], 0)) {
        if(!formData['terminationGiroAccountHolder']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroAccountHolder'][0].setInputError(`Please input valid GIRO bank account name`);
          return true;
        }

        if(!formData['terminationGiroEmail']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroEmail'][0].setInputError(`Please input valid GIRO bank account email`);
          return true;
        }

        let bankConfig = this.PARAM_MAP['terminationGiroBank'].form_select.data.find(k => helper.compareID(k.id, formData['terminationGiroBank']));
        if(!formData['terminationGiroBank'] || !bankConfig) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBank'][0].setInputError(`Please select valid GIRO bank`);
          return true;
        }

        let accountType = formData['terminationGiroBankAccountType'];
        if(!formData['terminationGiroBankAccountType']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountType'][0].setInputError(`Please select valid GIRO bank account type`);
          return true;
        }

        let bankAccountNo = formData['terminationGiroBankAccountNo'].trim();
        if(!bankAccountNo || !(/^\d+$/.test(bankAccountNo))) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountNo'][0].setInputError(`Please input valid GIRO bank account number`);
          return true;
        }
        
        let accountNoValid = false;
        let bankAccountConfigKey = accountType === 'current' ? 'ca' : 'sa'
        for(let bankAccountConfig of bankConfig[bankAccountConfigKey]) {
          if(bankAccountConfig.exact) {
            if(bankAccountNo.length === bankAccountConfig.exact) {
              accountNoValid = true;
              break;
            }
            if(bankAccountNo.length >= bankAccountConfig.min && bankAccountNo.length <= bankAccountConfig.max) {
              accountNoValid = true;
              break;
            }
          }
        }
        if(!accountNoValid) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBankAccountNo'][0].setInputError(`Please input valid GIRO bank account number`);
          return true;
        }

        if(!formData['terminationGiroNewIC'] && !formData['terminationGiroOldIC'] && !formData['terminationGiroBusinessRegNo']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationGiroBusinessRegNo'][0].setInputError(`Please fill in at least one of the GIRO Verification Method`);
          return true;
        }
      } else if(helper.compareID(formData['refundMethod'], 1)) {
        if(!formData['terminationChequePayableTo']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequePayableTo'][0].setInputError(`Please input valid cheque payable to field`);
          return true;
        }
        if(!formData['terminationChequeAddress1']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeAddress1'][0].setInputError(`Please input valid cheque address 1`);
          return true;
        }
        if(!formData['terminationChequePostalCode']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequePostalCode'][0].setInputError(`Please input valid cheque address postal code`);
          return true;
        }
        if(!formData['terminationChequeCity']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeCity'][0].setInputError(`Please input valid cheque address city`);
          return true;
        }
        if(!formData['terminationChequeState']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeState'][0].setInputError(`Please input valid cheque address state`);
          return true;
        }
        if(!formData['terminationChequeCountry']) {
          this.$refs['pageForm'].$refs['jt-form-element-terminationChequeCountry'][0].setInputError(`Please input valid cheque address country`);
          return true;
        }
      }
    },

		onPendingButtonClick() {
      if(this.validateRefundMethod()) {
        return
      }
			this.triggerPVaction('approve')
		},
		onSaveButtonClick() {
      if(this.validateRefundMethod()) {
        return
      }
			this.triggerPVaction('save')
		},
		onProcessButtonClick() {
      if(this.validateRefundMethod()) {
        return
      }
			this.triggerPVaction('process')
		},
		onCompleteButtonClick() {
			this.triggerPVaction('complete')
		},
		triggerPVaction(action) {
      if(!this.$refs['pageForm'].validateForm()) {
        let formData = this.$refs['pageForm'].formData;

        let dataref = {};
				dataref['applicationID'] = this.applicationCache['applicationID']
        dataref['description'] = formData['description']
        dataref['amount'] = formData['amount']
        dataref['refundMethod'] = formData['refundMethod']
        
        if(helper.compareID(formData['refundMethod'], 0)) {
          dataref['terminationGiroAccountHolder'] = formData['terminationGiroAccountHolder']
          dataref['terminationGiroEmail'] = formData['terminationGiroEmail']
          dataref['terminationGiroBank'] = formData['terminationGiroBank']
          let bankConfig = this.PARAM_MAP['terminationGiroBank'].form_select.data.find(k => helper.compareID(k.id, formData['terminationGiroBank']));
          dataref['terminationGiroBankName'] = bankConfig.name
          dataref['terminationGiroBankAccountType'] = formData['terminationGiroBankAccountType']
          dataref['terminationGiroBankAccountNo'] = formData['terminationGiroBankAccountNo']
          dataref['terminationGiroNewIC'] = formData['terminationGiroNewIC']
          dataref['terminationGiroOldIC'] = formData['terminationGiroOldIC']
          dataref['terminationGiroBusinessRegNo'] = formData['terminationGiroBusinessRegNo']
        } else if(helper.compareID(formData['refundMethod'], 1)) {
          dataref['terminationChequePayableTo'] = formData['terminationChequePayableTo']
          dataref['terminationChequeAddress1'] = formData['terminationChequeAddress1']
          dataref['terminationChequeAddress2'] = formData['terminationChequeAddress2']
          dataref['terminationChequeAddress3'] = formData['terminationChequeAddress3']
          dataref['terminationChequePostalCode'] = formData['terminationChequePostalCode']
          dataref['terminationChequeCity'] = formData['terminationChequeCity']
          dataref['terminationChequeState'] = formData['terminationChequeState']
          dataref['terminationChequeCountry'] = formData['terminationChequeCountry']
        }

      	this.$refs['pageFeedback'].setFeedbackLoading('Saving PV data');

				this.$http
					.post(
						helper.API_URL + '/api2/licenseRefund/' + action,
            querystring.stringify(dataref),
						helper.createAxiosFormConfig()
					)
					.then(response => {
						let resultMeta = helper.processAxiosResponse(this, response);
						formData.addressData1 = response.data;
						this.$refs['pageFeedback'].setFeedbackMessage('Successfully save PV data');

						this.pv = {}
						this.pageShowData = false
						this.pageShowPV = false
						this.loadApplication()
					})
					.catch(error => {
						this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'saving', 'PV data'));
					})
      }
		},

    hasAddOrEditPermission() {
			return helper.hasEditPermission(this.permission);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Refund/PagePaymentVoucher.vue